export const bathroomDialogues: any[] = [
    {
        id: 1,
        dialogue: [
            `[You wake up..]
<
            Alex: “What...
< 
            My head....
<
            What is going on...`,
        ],
        options: [{ id: 1, action: "Look around", roomId: 3 }],
    },
    {
        id: 2,
        dialogue: [
            `
        Alex: "I can't see anything, my eye sight is fully washed. Maybe i should clear my eyes"
        `,
        ],
        options: [
            { id: 1, action: "Look around", roomId: 3 },
            { id: 2, action: "Rub in your eyes", roomId: 3 },
        ],
    },
    {
        id: 3,
        dialogue: [
            `
        *I clear the dust in and around my eyes, i can see a lot clearer now.*
        `,
        ],
        options: [{ id: 1, action: "Look around", roomId: 3 }],
    },
    {
        id: 4,
        dialogue: [
            `
        Alex: "What is this?..
        <
        You try and get up from what seems to be a bathtub.
        <
        Alex: “My head..
        <
        hurts.. 
        <
        I..
        <
        I...
        <
        I can't even think...
        <
        I can see a mirror on the wall. 
        <
        Maybe i can see if i have some kind of wound".
        `,
        ],
        options: [{ id: 1, action: "Look into the mirror", roomId: 3 }],
    },
    {
        id: 5,
        dialogue: [
            `
        I see myself, my head hurts, there seems to be a dried up wound on the side of my head. I think i'm okay for now.
        <
        Alex: “Where am i..
        <
        I need to get out of here..”
        <
        The door.. i can't open it..
        <
        It seems to miss the door knob..
        <
        Maybe i can find something to open it..
        `,
        ],
        options: [
            { id: 1, action: "Look around", roomId: 3 },
            { id: 2, action: "Look deeper into the mirror", roomId: 3 },
            { id: 3, action: "Take a deep breath", roomId: 3 },
        ],
    },
    {
        id: 6,
        dialogue: [
            `
        As you walk around the room, you see some items around the room.
        <
        Alex: “A door knob..
        <
        An old towel on the towel rack..”
        `,
        ],
        options: [
            { id: 1, action: "Check the bathroom door", roomId: 3 },
            { id: 2, action: "Pick up the door knob", roomId: 3 },
            { id: 3, action: "Pick up the towel from the rack", roomId: 3 },
        ],
    },
    {
        id: 7,
        dialogue: [
            `
        I stare deeper into the mirror.
        <
        Alex: “What is that?..
        <
        WHAT?..
        <
        IS THAT BLOOD ON THE WALL?..”
        `,
        ],
        options: [
            { id: 1, action: "Look at the wall behind you", roomId: 3 },
            { id: 2, action: "Ignore wall, walk around the room", roomId: 3 },
        ],
    },
    {
        id: 8,
        dialogue: [
            `
        You look at the wall behind you.
        <
        Alex: "Oh thank god.. The red text on the wall does not seem to be blood, its some kind of red paint.. 
        <
        I feel so dizzy..
        <
        ...
        <
        I think what i'm seeing are some words..
        `,
        ],
        options: [{ id: 1, action: "Read the words", roomId: 3 }],
    },
    {
        id: 9,
        dialogue: [
            `
        You try to read the words on the wall.
        <
        Alex: "IT.. WAS.. 
        <
        i feel so sick.. 
        <
        what am i reading?..
        <
        IT.. WAS.. YOU. .
        <
        IT WAS YOU. 
        <
        What the hell is that supposed to mean?"
        `,
        ],
        options: [{ id: 1, action: "Look around the room", roomId: 3 }],
    },
    {
        id: 10,
        dialogue: [
            `
        You check the bathroom door.
        <
        Alex: “It's the door of the bathroom. 
        <
        It seems to have the door knob attached..”
        <
        *Struggles*
        <
        You find the grip and open the door. 
        <
        “That was rough.. but i got it.”
        `,
        ],
        options: [{ id: 1, action: "Leave the bathroom", roomId: 3 }],
    },
    {
        id: 11,
        dialogue: [
            `
        You check the bathroom door.
        <
        Alex: “It's the door of the bathroom. 
        <
        *Struggles*
        <
        You can't seem to open the door. 
        <
        “I have no grip.. my hands are so dirty..”
        `,
        ],
        options: [
            { id: 1, action: "Look around the room", roomId: 3 },
            { id: 2, action: "Check the door again", roomId: 3 },
        ],
    },
    {
        id: 12,
        dialogue: [
            `
        You check the bathroom door.
        <
        Alex: “It's the door of the bathroom.
        <
        i can't seem to open the door. 
        ”
        `,
        ],
        options: [
            { id: 1, action: "Look around the room", roomId: 3 },
            { id: 2, action: "Check the door again", roomId: 3 },
        ],
    },
    {
        id: 13,
        dialogue: [
            `
        You take a deep breath and it eases your mind a little..
        <
        Alex: “Wait... where..
        <
        Em....
        <
        Emily.....
        <
        EEMMMIILLYYYY?!?!...
        <
        Oh no... 
        <
        Where are you..
        <
        In need to get out of here..
        <
        I got to find her...
        ”
        `,
        ],
        options: [{ id: 1, action: "Smash the locked door (HP -5)", roomId: 3 }],
    },
    {
        id: 14,
        dialogue: [
            `
        You smashed the door, it still won't open and you hurt you hurt your shoulder a bit..
        <
        Alex: “Come on..
        <
        COME ON!!..”
        `,
        ],
        options: [
            { id: 1, action: "Smash the locked door again (HP -10)", roomId: 3 },
            { id: 2, action: "Look around the room", roomId: 3 },
        ],
    },
    {
        id: 15,
        dialogue: [
            `
        You smashed the door again, it still won't open and you hurt your shoulder a lot more..
        <
        Alex: “AAH... 
        <
        fuck...
        <
        my shoulder..
        <
        COME ON!!..”
        `,
        ],
        options: [
            { id: 1, action: "Smash the locked door again (HP -5)", roomId: 3 },
            { id: 2, action: "Look around the room", roomId: 3 },
        ],
    },
    {
        id: 16,
        dialogue: [
            `
        You smash the door one more time, it seems to have come lose, it just requires one last push..
        <
        Alex: “Come on..
        <
        It's almost there..
        <
        i got this..”
        `,
        ],
        options: [{ id: 1, action: "Smash the door one more time", roomId: 3 }],
    },
    {
        id: 17,
        dialogue: [
            `
        You seem to have cracked open the door, the door is now open.
        <
        Alex: “Ah..
        <
        Finally..
        <
        I got to find Emily quick..
        <
        Please let her be okay..”
        `,
        ],
        options: [{ id: 1, action: "Leave the bathroom", roomId: 3 }],
    },
    {
        id: 30,
        dialogue: [
            `Alex: "Maybe i missed something..
        <
        But i've got to hurry, i need to find Emily.." 
        `,
        ],
        options: [{ id: 1, action: "Look around", roomId: 3 }],
    },
    {
        id: 31,
        dialogue: [
            `
        Alex: "That wall.. it looks strange..
        <
        Wait.. What the hell is that?.."
        `,
        ],
        options: [
            { id: 1, action: "Look at the strange wall", roomId: 3 },
            { id: 2, action: "Inspect the strange object", roomId: 3 },
        ],
    },
    {
        id: 32,
        dialogue: [
            `
        Alex: "Hm.. what is that?.." 
        `,
        ],
        options: [{ id: 1, action: "Look around", roomId: 3 }],
    },
    {
        id: 33,
        dialogue: [
            `
        *You look at the strange wall*
        <
        Alex: "I think what i'm seeing are some words.."
        `,
        ],
        options: [{ id: 1, action: "Read the words", roomId: 3 }],
    },
    {
        id: 34,
        dialogue: [
            `
        You try to read the words on the wall.
        <
        Alex: "IT.. WAS.. 
        <
        what am i reading?..
        <
        IT.. WAS.. YOU. .
        <
        IT WAS YOU. 
        <
        What the hell is that supposed to mean?"
        `,
        ],
        options: [{ id: 1, action: "Look around", roomId: 3 }],
    },
    {
        id: 35,
        dialogue: [
            `
        Alex: "I dont think there is anything to find anymore..
        <
        I should continue finding Emily..
        "
        `,
        ],
        options: [],
    },
    {
        id: 99,
        dialogue: ["Trigger going to the hotelroom of this bathroom id=99"],
        options: [{ id: 1, action: "temp go back to dialogue 1 of this room.", roomId: 3 }],
    },
];
